import { GET, DELETE } from 'utils/requests.utils'
import { HTTPResponse } from 'types/responses'

const BASE_URL = (id) => `/cabinet/sales_teams/${id}/sales_team_members`

export const fetchList = ({ salesTeamId, ...restData }) => GET<HTTPResponse>(BASE_URL(salesTeamId), restData)

export const deleteItem = ({ id, salesTeamId }) => DELETE<HTTPResponse>(`${BASE_URL(salesTeamId)}/${id}`)
